// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3q3S7","title":"Info_title__B9l4Y","selects":"Info_selects__1qjc3","requiredAsterisk":"Info_requiredAsterisk__23bAG"};